import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment TestimonialSimpleCenteredData on StrapiComponentTestimonialSimpleCentered {
    testimonial {
      name
      jobTitle
      text
      image {
        ...StrapiMediaSubquery
      }
      companyLogo {
        ...StrapiSharedLink
      }
    }
  }
`;

function SimpleCentered({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <section className="overflow-hidden bg-background-off-white py-12 md:py-20 lg:py-24">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <svg
          className="absolute right-full top-full -translate-y-1/4 translate-x-1/3 transform lg:translate-x-1/2 xl:-translate-y-1/2"
          width={404}
          height={404}
          fill="none"
          viewBox="0 0 404 404"
          role="img"
          aria-labelledby="svg-workcation"
        >
          <defs>
            <pattern
              id="ad119f34-7694-4c31-947f-5c9d249b21f3"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className="text-text-light-gray"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={404}
            fill="url(#ad119f34-7694-4c31-947f-5c9d249b21f3)"
          />
        </svg>

        <div className="relative">
          {(data.testimonial?.companyLogo?.overwriteIcon ||
            data.testimonial?.companyLogo?.link?.icon) && (
            <LinkWrapper
              to={data.testimonial?.companyLogo?.link?.url}
              className="inline-flex"
            >
              <MediaWrapper
                media={
                  data.testimonial.companyLogo.overwriteIcon ||
                  data.testimonial.companyLogo.link.icon
                }
                divClassName="mx-auto h-8"
                objectFit="contain"
              />
            </LinkWrapper>
          )}
          <blockquote className="mt-10">
            {data.testimonial.text && (
              <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-text-primary">
                <MarkdownWrapper
                  text={`&ldquo;${data.testimonial.text}&rdquo;`}
                  replaceParagraph={false}
                />
              </div>
            )}
            <footer className="mt-8">
              <div className="md:flex md:items-center md:justify-center">
                {data.testimonial.image && (
                  <div className="md:flex-shrink-0">
                    <MediaWrapper
                      media={data.testimonial.image}
                      divClassName="mx-auto h-10 w-10"
                      className="rounded-full"
                    />
                  </div>
                )}
                <div className="mt-3 text-center md:ml-4 md:mt-0 md:flex md:items-center">
                  {data.testimonial.name && (
                    <div className="text-base font-medium text-text-primary">
                      {data.testimonial.name}
                    </div>
                  )}

                  <svg
                    className="mx-1 hidden h-5 w-5 text-text-primary md:block"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M11 0h3L9 20H6l5-20z" />
                  </svg>
                  {data.testimonial.jobTitle && (
                    <div className="text-base font-medium text-text-secondary">
                      <MarkdownWrapper text={data.testimonial.jobTitle} />
                    </div>
                  )}
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}

SimpleCentered.propTypes = {
  data: PropTypes.object,
};

export default SimpleCentered;
